// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_m57","cls2":"ProfilePdfPackCard-cls2_E4_ ProfilePdfPackCard-cls1_m57"};